module.exports = __webpack_public_path__ + "static/fipcmintorg2-573e36ab2c6bec90dfff5e92ce519f69.jpeg";